import { LOCAL_STORAGE_AUTH_KEY } from '../config/constants'
import { CONNECT_SUBSCRIPTION_KEY, FACILITY_SUBSCRIPTION_KEY } from '../config/auth0'
import store from 'store'

export const authorizeHeader = (config) => {
  let accessToken = 'Bearer ' + store.get(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN)
  if (config && config.headers) {
    config.headers['Authorization'] = accessToken
    if (!config.headers['Ocp-Apim-Subscription-Key']) config.headers['Ocp-Apim-Subscription-Key'] = CONNECT_SUBSCRIPTION_KEY
  } else {
    config['headers'] = {
      'Authorization': accessToken,
      'Ocp-Apim-Subscription-Key': CONNECT_SUBSCRIPTION_KEY
    }
  }
  return config
}
export const facilityAuthorizeHeader = (config) => {
  let accessToken = 'Bearer ' + store.get(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN)
  if (config && config.headers) {
    config.headers['Authorization'] = accessToken
    if (!config.headers['Ocp-Apim-Subscription-Key']) config.headers['Ocp-Apim-Subscription-Key'] = FACILITY_SUBSCRIPTION_KEY
  } else {
    config['headers'] = {
      'Authorization': accessToken,
      'Ocp-Apim-Subscription-Key': FACILITY_SUBSCRIPTION_KEY
    }
  }
  return config
}


